import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ContactAvatar from "../ContactAvatar";
import { contactDisplayName } from "../../utils/contactPresentation";
import WaitingStatus from "../WaitingStatus";
import ExactTime from "../ExactTime";
import MarkdownWrapper from "../MarkdownWrapper";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useReplyNotifications } from "../../context/ReplyNotifications";

const useStyles = makeStyles(theme => ({
  paper: { borderRadius: 20, width: 480, margin: 16, maxWidth: "calc(100% - 32px)" },
  title: { padding: "20px 22px 12px" },
  heading: { display: "flex", alignItems: "center", gap: 12 },
  name: { flex: 1, minWidth: 0 },
  avatar: { width: 46, height: 46 },
  subtitle: { fontSize: ".75rem", color: theme.palette.text.secondary, marginTop: 3 },
  content: { padding: "8px 22px 20px" },
  meta: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, margin: "20px 0", "& dt": { color: theme.palette.text.secondary, fontSize: ".72rem" }, "& dd": { margin: "4px 0 0", fontSize: ".85rem", overflowWrap: "anywhere" } },
  message: { border: "1px solid " + theme.custom.border, borderRadius: 12, padding: 14, background: theme.custom.surface, overflowWrap: "anywhere", fontSize: ".85rem", "& p": { margin: "5px 0" } },
  label: { fontSize: ".7rem", fontWeight: 700, color: theme.palette.text.secondary, marginBottom: 7 },
  time: { display: "block", color: theme.palette.text.secondary, marginTop: 10, fontSize: ".72rem", fontVariantNumeric: "tabular-nums" },
  actions: { padding: "4px 22px 20px", gap: 8 },
  active: { padding: "12px 14px", borderRadius: 12, background: theme.custom.sidebarActiveBg, color: theme.palette.primary.main, fontWeight: 700, fontSize: ".85rem" },
}));

const TicketPreviewModal = ({ ticket, open, onClose, onAccept, accepting = false }) => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);
  const { markTicketSeen } = useReplyNotifications();
  const ticketId = ticket?.id;
  const ownTicket = !!ticket && String(ticket.userId) === String(user?.id);
  // Ver a última mensagem na prévia também conta como visualizar a resposta.
  useEffect(() => {
    if (open && ownTicket && ticketId) markTicketSeen(ticketId);
  }, [open, ownTicket, ticketId, markTicketSeen]);
  if (!ticket) return null;
  return <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" classes={{ paper: classes.paper }} aria-labelledby="ticket-preview-title">
    <DialogTitle className={classes.title} disableTypography>
      <div className={classes.heading}>
        <ContactAvatar contact={ticket.contact} className={classes.avatar} />
        <div className={classes.name}><Typography variant="h6" noWrap id="ticket-preview-title">{contactDisplayName(ticket.contact)}</Typography><div className={classes.subtitle}>Atendimento #{ticket.id}</div></div>
        <IconButton aria-label="Fechar detalhes" onClick={onClose} size="small"><CloseIcon /></IconButton>
      </div>
    </DialogTitle>
    <DialogContent className={classes.content}>
      {ticket.status === "pending" ? <WaitingStatus ticket={ticket} expanded /> : <div className={classes.active}>{ticket.status === "closed" ? "Atendimento concluído" : "Em atendimento"}</div>}
      <dl className={classes.meta}>
        <div><dt>Responsável</dt><dd>{ticket.user?.name || (ticket.status === "pending" ? "Aguardando aceite" : ticket.userId ? "Atendente #" + ticket.userId : "Sem responsável registrado")}</dd></div>
        <div><dt>Fila</dt><dd>{ticket.queue?.name || "Sem fila"}</dd></div>
        <div><dt>Conexão</dt><dd>{ticket.whatsapp?.name || "—"}</dd></div>
        <div><dt>Criado em</dt><dd><ExactTime value={ticket.createdAt} label="Criação do atendimento" /></dd></div>
      </dl>
      <div className={classes.message}>
        <div className={classes.label}>ÚLTIMA MENSAGEM</div>
        {ticket.lastMessage ? <MarkdownWrapper>{ticket.lastMessage}</MarkdownWrapper> : "Nenhuma mensagem registrada."}
        {ticket.lastMessageAt ? <ExactTime value={ticket.lastMessageAt} className={classes.time} /> : <span className={classes.time}>Horário da mensagem indisponível</span>}
      </div>
    </DialogContent>
    <DialogActions className={classes.actions}>
      <Button onClick={onClose}>Fechar</Button>
      {ticket.status === "pending" && onAccept ? <Button color="primary" variant="contained" disabled={accepting} onClick={() => onAccept(ticket.id)}>{accepting ? "Aceitando…" : "Aceitar atendimento"}</Button> : <Button color="primary" variant="contained" onClick={() => { onClose(); history.push("/tickets/" + ticket.id); }}>Abrir atendimento</Button>}
    </DialogActions>
  </Dialog>;
};
export default TicketPreviewModal;
